// removed by extract-text-webpack-plugin
module.exports = {"avatarUploader":"style__avatarUploader__1ZLz2","avatarUploaderTrigger":"style__avatarUploaderTrigger__1YCNf","avatar":"style__avatar__3wY63","satUploader":"style__satUploader__ijxh1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/Widgets/ImageWidget/style.less
// module id = 1152
// module chunks = 0